var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('editor',{attrs:{"tinymce-script-src":"/tinymce/tinymce.min.js","disabled":_vm.disabled,"init":_vm.editorConfig,"model-events":"change input keydown blur focus paste"},model:{value:(_vm.templateHtml),callback:function ($$v) {_vm.templateHtml=$$v},expression:"templateHtml"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }